export const ACCOUNT_INFO_SECOND: any = {
  KOR: {
    firstName: {
      pattern: /^\S[가-힣]*$/,
      message: '한글로 입력해주세요.',
      label: '성',
      placeholder: '예) 홍',
    },
    secondName: {
      pattern: /^\S[가-힣]*$/,
      message: '한글로 입력해주세요.',
      label: '이름',
      placeholder: '예) 길동',
    },
    birth: {
      label: '생년월일',
    },
    phoneNumber: {
      label: '연락처',
    },
  },
  CHN: {
    firstName: {
      pattern: /^\S[\u4e00-\u9fa50-9]*$/,
      message: '请用中文输入。',
      label: '姓(中文)',
      placeholder: '姓 仅限中文',
    },
    secondName: {
      pattern: /^\S[\u4e00-\u9fa50-9]*$/,
      message: '请用中文输入。',
      label: '名字(中文)',
      placeholder: '名字 仅限中文',
    },
    birth: {
      label: '生日',
    },
    phoneNumber: {
      label: '手机号码',
    },
  },
  JPN: {
    firstName: {
      pattern: /^\S[\u3040-\u30FF0-9]*$/,
      message: 'Please enter in Japanese.',
      label: '受取人名 (姓) / カタカナ',
      placeholder: 'Surname in Katakana',
    },
    secondName: {
      pattern: /^\S[\u3040-\u30FF0-9]*$/,
      message: 'Please enter in Japanese.',
      label: '受取人名 (名) / カタカナ',
      placeholder: 'Given Names in Katakana',
    },
    birth: {
      label: '誕生日',
    },
    phoneNumber: {
      label: '携帯電話番号',
    },
  },
  THA: {
    firstName: {
      pattern: /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/,
      message: 'Please enter only English and numbers.',
      label: 'ชื่อ',
      placeholder: 'Given Names in English',
    },
    secondName: {
      pattern: /^[a-zA-Z0-9][a-zA-Z0-9\s]*$/,
      message: 'Please enter only English and numbers.',
      label: 'นามสกุล',
      placeholder: 'Surname in English',
    },
    birth: {
      label: 'วันเกิด',
    },
    phoneNumber: {
      label: 'หมายเลขโทรศัพท',
    },
  },
};
